import React, { Component } from 'react';
export class PageLoaderComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loadingMessage: props.loadingMessage !== undefined && props.loadingMessage !== "" ? props.loadingMessage : "Please wait..."
        }
    }
    //const classes = useStyles();
    render() {
        return (
            <>
                <div className="page-loading text-center">
                    <div className="content">
                        <img
                            src="../../dist/img/logo_white_utwiz.png"
                            className="flipimg"
                            width={"50px"}
                        ></img>{" "}
                        <h6 className="mb-0">{this.state.loadingMessage}</h6>
                    </div>
                </div>
            </>
        )
    }
}
